module.exports = __webpack_public_path__ + "static/img/green.ffb180e0.png";